<form class="ami-wrap" (ngSubmit)="submit()">

  <!-- Large textarea -->
  <textarea
    class="ami-textarea"
    name="assistantQuery"
    [(ngModel)]="draft"
    placeholder="Message Octy..."
    aria-label="Write a query"
    (keydown.enter)="submitFromKeyboard($event)"
  ></textarea>

  <!-- Bottom action bar -->
  <div class="ami-bar">

    <!-- Agent pill with dropdown -->
    <div class="ami-pill-wrap">
      <button
        type="button"
        class="ami-agent-pill"
        (click)="toggleDropdown($event)"
        aria-haspopup="listbox"
        [attr.aria-expanded]="dropdownOpen"
      >
        <span class="ami-agent-icon" [style.background]="activeAgent.color + '22'">
          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" [attr.stroke]="activeAgent.color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path [attr.d]="getAgentSvg(activeAgent.icon)"/>
          </svg>
        </span>
        <span class="ami-agent-label" [style.color]="activeAgent.color">{{ activeAgent.name }}</span>
        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
             [style.transform]="dropdownOpen ? 'rotate(180deg)' : 'rotate(0)'"
             style="transition: transform 180ms ease; color: rgba(255,255,255,0.35)">
          <polyline points="6 9 12 15 18 9"/>
        </svg>
      </button>

      <!-- Dropdown -->
      <div class="ami-dropdown" *ngIf="dropdownOpen" role="listbox" (click)="$event.stopPropagation()">
        <button
          *ngFor="let agent of agents"
          type="button"
          class="ami-dropdown-item"
          [class.ami-dropdown-item--active]="agent.id === activeAgent.id"
          role="option"
          [attr.aria-selected]="agent.id === activeAgent.id"
          (click)="selectAgent(agent)"
        >
          <span class="ami-dropdown-icon" [style.background]="agent.color + '22'">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" [attr.stroke]="agent.color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path [attr.d]="getAgentSvg(agent.icon)"/>
            </svg>
          </span>
          <div class="ami-dropdown-info">
            <span class="ami-dropdown-name">{{ agent.name }}</span>
            <span class="ami-dropdown-desc">{{ agent.description }}</span>
          </div>
          <svg *ngIf="agent.id === activeAgent.id" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="color:rgba(255,255,255,0.5); flex-shrink:0"><polyline points="20 6 9 17 4 12"/></svg>
        </button>
      </div>
    </div>

    <!-- Right: send -->
    <button type="submit" class="ami-send" aria-label="Send message" [disabled]="!draft.trim()">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <line x1="12" y1="19" x2="12" y2="5"/>
        <polyline points="5 12 12 5 19 12"/>
      </svg>
    </button>
  </div>

</form>
